<template>
  <div :class="className" :style="{ height: height, width: width }"></div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-wordcloud';
require('echarts/theme/macarons'); // echarts theme
import { debounce } from '@/utils';

// const animationDuration = 6000;

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '180px'
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions(data) {
      var maskImage = new Image();
      maskImage.src =
        'data:image/png;base64,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';
      let self = this;
      maskImage.onload = function() {
        self.chart.setOption({
          tooltip: {
            show: true,
            borderColor: '#fe9a8bb3',
            borderWidth: 1,
            padding: [5, 10, 5, 10],
            confine: true,
            backgroundColor: 'rgba(255, 255, 255, .9)',
            textStyle: {
              color: 'hotpink',
              lineHeight: 22
            },
            extraCssText:
              'box-shadow: 0 4px 20px -4px rgba(199, 206, 215, .7);border-radius: 4px;'
          },
          series: [
            {
              type: 'wordCloud',
              // shape: 'triangle',
              maskImage: maskImage,
              left: 'center',
              top: 'center',
              width: '100%',
              height: '100%',
              right: null,
              bottom: null,
              sizeRange: [8, 20],
              // Text rotation range and step in degree. Text will be rotated randomly in range [-90, 90] by rotationStep 45
              rotationRange: [0, 0],
              // rotationStep: 5,
              gridSize: 2,
              // set to true to allow word being draw partly outside of the canvas.
              // Allow word bigger than the size of the canvas to be drawn
              drawOutOfBound: false,
              // If perform layout animation.
              // NOTE disable it will lead to UI blocking when there is lots of words.
              layoutAnimation: true,
              // Global text style
              textStyle: {
                fontFamily: 'PingFangSC-Semibold',
                color: function(params) {
                  return `rgba(60,170,69,${params.value / 5})`;
                }
              },
              emphasis: {
                focus: 'none'
              },

              // Data is an array. Each array item must have name and value property.
              data: data.seriesData
            }
          ]
        });
      };
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};
</script>
